import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import { Checkbox, ListItemText, Box, Typography } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles((theme) => ({
  container: {
    minWidth: 110,
    margin: "0 4px",
  },
  formControl: {
    width: "100%",
  },
  selectRoot: {
    display: "flex",
    alignItems: "center",
    fontSize: "0.82rem",
    fontWeight: 600,
    color: theme.palette.text.secondary,
    padding: "6px 12px !important",
    borderRadius: "10px !important",
    backgroundColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.05)" : "#f8fafc",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.12)" : "#e2e8f0"}`,
    transition: "all 0.2s ease",
    "&:hover": {
      borderColor: "#0D9488",
      backgroundColor: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.08)" : "#f1f5f9",
    },
    "&.Mui-focused": {
      borderColor: "#0D9488",
      boxShadow: "0 0 0 2px rgba(13,148,136, 0.2)",
    },
  },
  selectIcon: {
    right: 8,
    color: theme.palette.text.secondary,
    fontSize: 20,
    pointerEvents: "none",
  },
  menuPaper: {
    borderRadius: 12,
    marginTop: 6,
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.12)",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.08)" : "#e4e7ec"}`,
    maxHeight: 280,
  },
  colorDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    display: "inline-block",
    marginRight: 8,
    flexShrink: 0,
  },
  countBadge: {
    backgroundColor: "#0D9488",
    color: "#fff",
    borderRadius: 10,
    padding: "1px 6px",
    fontSize: "0.72rem",
    fontWeight: 700,
    marginLeft: 4,
  },
}));

const TicketsQueueSelect = ({
  userQueues,
  selectedQueueIds = [],
  onChange,
}) => {
  const classes = useStyles();

  const handleChange = (e) => {
    onChange(e.target.value);
  };

  const hasSelected = selectedQueueIds && selectedQueueIds.length > 0;

  return (
    <div className={classes.container}>
      <FormControl className={classes.formControl} size="small">
        <Select
          multiple
          displayEmpty
          disableUnderline
          IconComponent={ExpandMoreIcon}
          value={selectedQueueIds}
          onChange={handleChange}
          classes={{
            root: classes.selectRoot,
            icon: classes.selectIcon,
          }}
          MenuProps={{
            transitionDuration: 150,
            anchorOrigin: {
              vertical: "bottom",
              horizontal: "left",
            },
            transformOrigin: {
              vertical: "top",
              horizontal: "left",
            },
            getContentAnchorEl: null,
            classes: { paper: classes.menuPaper },
          }}
          renderValue={() => (
            <Box display="flex" alignItems="center" style={{ gap: 4 }}>
              <span>{i18n.t("ticketsQueueSelect.placeholder")}</span>
              {hasSelected && (
                <span className={classes.countBadge}>
                  {selectedQueueIds.length}
                </span>
              )}
            </Box>
          )}
        >
          {userQueues?.length > 0 &&
            userQueues.map((queue) => (
              <MenuItem dense key={queue.id} value={queue.id}>
                <Checkbox
                  style={{
                    color: queue.color || "#0D9488",
                    padding: "4px 8px",
                  }}
                  size="small"
                  checked={selectedQueueIds.indexOf(queue.id) > -1}
                />
                <span
                  className={classes.colorDot}
                  style={{ backgroundColor: queue.color || "#0D9488" }}
                />
                <ListItemText
                  primary={queue.name}
                  primaryTypographyProps={{
                    style: { fontSize: "0.85rem", fontWeight: 500 },
                  }}
                />
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default TicketsQueueSelect;
